import HouseIcon from '@mui/icons-material/House';
import InstagramIcon from '@mui/icons-material/Instagram';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: 4,
                }}
            >
                <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
                    <Typography
                        align={'left'}
                        variant={'h6'}
                        color="text.primary"
                        gutterBottom
                    >
                        Contact Us
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            flexDirection: 'row',
                            alignItems: 'center',
                            mb: 1,
                        }}
                    >
                        <HouseIcon />
                        <Typography
                            align={'left'}
                            variant={'body2'}
                            color="text.primary"
                        >
                            Heart House Jl. Katalia Raya No.5 Kota Bambu,
                            Jakarta Barat
                        </Typography>
                    </Box>
                    <Box
                        component="a"
                        href="mailto:pokja.inaacc@gmail.com"
                        sx={{
                            textDecoration: 'none',
                            color: 'text.primary',
                            display: 'flex',
                            gap: 1,
                            flexDirection: 'row',
                            alignItems: 'center',
                            mb: 1,
                        }}
                    >
                        <MailOutlineIcon />
                        <Typography
                            align={'left'}
                            variant={'body2'}
                            color="text.primary"
                        >
                            pokja.inaacc@gmail.com
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            flexDirection: 'row',
                            alignItems: 'center',
                            textDecoration: 'none',
                            color: 'text.primary',
                        }}
                        component="a"
                        href="https://wa.me/6285121370236"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsAppIcon />
                        <Typography
                            align={'left'}
                            variant={'body2'}
                            color="text.primary"
                        >
                            +62 851-2137-0236 (INAACC Team)
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
                    <Typography
                        align={'left'}
                        variant={'h6'}
                        color="text.primary"
                        gutterBottom
                    >
                        Social Media
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <IconButton
                            aria-label="WhatsApp"
                            size="small"
                            component="a"
                            href="https://wa.me/6285121370236"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <WhatsAppIcon />
                        </IconButton>
                        <IconButton
                            aria-label="Instagram"
                            size="small"
                            component="a"
                            href="https://www.instagram.com/pokjaaccperki"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <InstagramIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ mt: 4 }}>
                <Typography
                    align={'center'}
                    variant={'body2'}
                    color="text.primary"
                    gutterBottom
                >
                    InaACC ©{year}
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;
